import { render, staticRenderFns } from "./course-list-header.vue?vue&type=template&id=65bf09a8&scoped=true"
import script from "./course-list-header.vue?vue&type=script&lang=js"
export * from "./course-list-header.vue?vue&type=script&lang=js"
import style0 from "./course-list-header.vue?vue&type=style&index=0&id=65bf09a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bf09a8",
  null
  
)

export default component.exports